/* eslint-disable */
import React, { useEffect } from 'react';
import {
    Box,
    List,
    ListItem,
    Card,
    CardContent,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataListRow from './dataListRow';
import { createTheme } from '@mui/material/styles';
import EnhancedTableToolbar from '../../../../sharedcomponents/tableToolbar/tableToolbar';
import Paging from '../../../../sharedcomponents/pagination/pagination';
import { useEventState } from '../../../../stores/eventStore';
import { useState } from '@hookstate/core';
import Title from '../../../../sharedcomponents/title/title';
import DraggableList from './draggableList';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    boxContent: {
        // paddingTop: theme.spacing(1),
    },
    listContent: {
        paddingBottom: theme.spacing(0),
        paddingTop: theme.spacing(0),
        zIndex: 0
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
    }
}));

const DataList = (props) => {
    const classes = useStyles();
    const [listData, setListData] = React.useState([]);
    const [filterListData, setFilterListData] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const eventState = useEventState();
    const moduleIndex = useState(0)
    useEffect(() => {
        if (listData && listData.length == 0 && filterListData.length == 0) {
            setListData(props.data);
            setFilterListData(props.data);
        }
        else if (props.showSearchRec && props.data.length != listData.length) {
            setListData(props.data);
            setFilterListData(props.data);
        }
        else if (!props.showSearchRec) {
            setListData(props.data);
            setFilterListData(props.data);
        }

        if (eventState && eventState.eventDetail.get() != null && props.moduleToShow != undefined) {
            getModuleDetailsData();
        }

    }, [props.data, props.showSearchRec]);

    const getModuleDetailsData = () => {
        const index = eventState.eventDetail.get().moduleDetails.findIndex((element) => {
            if (element.moduleName === props.moduleToShow) {
                return true
            }
        });
        moduleIndex.set(index);
    }

    // this need to be modified
    const handleFilterChangeValue = (filterObj) => {
        let modifyList = listData.filter(item => {
            const data = item.actualData;
            if (filterObj) {
                return Object.keys(filterObj).every(filter => {
                    let val = (typeof filterObj[filter] === 'string' && filter === 'transportType') ? filterObj[filter].toLowerCase() : filterObj[filter];
                    return val.includes(data[filter]);
                });
            }
        });

        if (filterObj) {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(true);
            }
            setFilterListData(modifyList);
            props.filterListData(modifyList)

        }
        else {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(false);
            }
            setFilterListData(listData);
            if (props.filterListData)
                props.filterListData(listData)

        }
    }

    const handleOnChange = (event) => {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        if (value.length > 0) {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(true);
            }
            let modifyList = [];
            listData.forEach((item) => {
                let data = item.actualData;
                let keys = Object.keys(data);
                keys.forEach((key) => {
                    if (
                        typeof data[key] === 'string' &&
                        data[key].toLowerCase().indexOf(value.toLowerCase()) > -1
                    ) {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                });
            });
            setFilterListData(modifyList);
            if (props.filterListData)
                props.filterListData(modifyList)

        } else {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(false);
            }
            setFilterListData(listData);
            if (props.filterListData)
                props.filterListData(listData)
        }
    };
    const onCheckSelect = (event, index) => {
        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.checked;
        setFilterListData(newFilterList);
    }
    return (
        <Box className={classes.boxContent}>
            <Title title={props.moduleToShow} />
            <EnhancedTableToolbar
                {...props}
                search={search}
                showSendAll={props.showSendAll ? true : false}
                sendAllbuttonTitle={props.showSendAll ? "Send All" : null}
                showEdit={props.showEdit ? true : false}
                editButtonTitle={props.showEdit ? true : false}
                handleSearchChange={handleOnChange}
                handleFilterChange={handleFilterChangeValue}
                handleSendEmail={props.handleSendEmail}
                hideAdd={props.hideAdd ? true : false}
                modPermission={props.modPermission}
                deleteRows={props.deleteRows}
                disableAdd={props.disableAdd}
            />

            {
                props.isDraggable != undefined ? (
                    <DraggableList
                        classes={classes}
                        data={filterListData}
                        onDragEnd={props.onDragEnd}
                        onCheckSelect={onCheckSelect}
                        editRow={props.editRow}
                        viewPage={props.viewPage}
                        modPermission={props.modPermission}
                    />
                ) :
                    <List className={classes.listContent}>
                        {filterListData && filterListData.length > 0 ? (
                            filterListData.map((item, index) => (
                                <DataListRow
                                    {...props}
                                    key={`datarow_${index}`}
                                    item={item}
                                    index={index}
                                    onCheckSelect={onCheckSelect}
                                    editRow={props.editRow}
                                    modPermission={props.modPermission}

                                />
                            ))
                        ) : (
                            <ListItem className={classes.listItemContent}>
                                <Card
                                    classes={{ root: classes.paperContent }}
                                    sx={{ width: '100%' }}>
                                    <CardContent
                                        sx={{ p: 2 }}
                                        className={classes.cardContent}>
                                        <Box className={classes.rowContent}>
                                            No data found
                                        </Box>
                                    </CardContent>
                                </Card>
                            </ListItem>
                        )}
                    </List>
            }

            {props.pagingInfo && props.pagingInfo.noOfPages > 1 && !props.showSearchRec ? (
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Paging
                        pagingInfo={props.pagingInfo}
                        handlePageChange={props.handlePageChange}
                    />
                </Box>
            ) : null}
        </Box>
    );
};

export default DataList;
